export const CANDIDATE_DETAILS = [
  { label: 'ID', value: 'id' },
  { label: 'Status', value: 'currentState' },
  { label: 'Organization Name', value: 'organisation.name' },
  { label: 'Country', value: 'organisation.countryCode' },
  { label: 'Rejection Reason', value: 'rejectionReason' }
] as const

export const DISBURSEMENTS = [
  { label: 'Award Amount', value: 'award.amount' },
  { label: 'Award Currency', value: 'award.currency' },
  { label: 'Donation Status', value: 'paymentDetails.status' },
  { label: 'Donation Amount', value: 'paymentDetails.payment.amount' },
  { label: 'Donation Currency', value: 'paymentDetails.payment.currency' },
  { label: 'Donation Paid At', value: 'paymentDetails.paidAt' }
] as const
